(function ($, window, document) {
	/**
	 *   ... code out here will run immediately on load
	 */

	const debounce = function (func, delay) {
		let timer;
		return function () {
			//anonymous function
			const context = this;
			const args = arguments;
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(context, args);
			}, delay);
		};
	};
	const throttle = (func, limit) => {
		let inThrottle;
		return function () {
			const args = arguments;
			const context = this;
			if (!inThrottle) {
				func.apply(context, args);
				inThrottle = true;
				setTimeout(() => (inThrottle = false), limit);
			}
		};
	};
	/**
	 *
	 *   ... code in here will run after jQuery says document is ready
	 */
	$(function () {
		//
		if ($(".page-sidebar-container").length != 0) {
			const sidebarWidth = $("body").css("--sidebar--width");
			$(".page-sidebar-container").on(
				"click",
				".page-sidebar-toggle",
				function (e) {
					$(e.delegateTarget).toggleClass("is-tucked-away");
					$("body").toggleClass("page-sidebar-is-tucked-away");
				}
			);
		}

		if ($(".jump-nav a").length) {
			$(".jump-nav a").click(function () {
				$(".jump-nav a.active").removeClass("active");
				$(this).addClass("active");
			});
		}



		// root is the browser viewport / screen
		// var observer = new IntersectionObserver(
		// 	function (entries) {
		// 		entries.forEach((entry) => {
		// 			if (entry["intersectionRatio"] === 1) {
		// 				// console.log("More than 50% of target is visible in the screen");
		// 				// let chartInstance = pie_chart_handler._init();
		// 			}
		// 		});
		// 	},
		// 	{ threshold: [0, 0.5, 1] }
		// );
		// observer.observe(document.querySelector(".pie-chart-container"));

		//
	});
})(window.jQuery, window, document);
